export default __webpack_public_path__ + "static/shapes-77ff95bedce5caf0f17fcbdc75b5ec17.png";